import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/course.css";
import api from './api';


const CoursePage = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [wishlistCourses, setWishlistCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('my-courses');
    const [wishlistIds, setWishlistIds] = useState(new Set());
    const [loadingWishlist, setLoadingWishlist] = useState(false);

    const getRandomColor = () => {
        const colors = ['#2BA769', '#4D8BFF', '#FFB800', '#FF6B6B', '#8E44AD', '#00B894'];
        return colors[Math.floor(Math.random() * colors.length)];
    };

    // دریافت دوره‌های من
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await api.get('/pre_student/api/v3/my-packages/?page=1&page_size=10');

                if (response.data && response.data.results && response.data.results.packages) {
                    const updatedCourses = response.data.results.packages.map(course => ({
                        ...course,
                        progressColor: getRandomColor(),
                        isInWishlist: wishlistIds.has(course.id)
                    }));

                    setCourses(updatedCourses);
                }
            } catch (error) {
                console.error("خطا در دریافت دوره‌ها:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, [wishlistIds]);

    // دریافت لیست علاقه‌مندی‌ها
    const fetchWishlist = async () => {
        try {
            const response = await api.get('/pre_student/api/v3/wishlist/');

            if (response.data && response.data.wishlist) {
                const updatedWishlist = response.data.wishlist.map(course => ({
                    ...course,
                    progressColor: getRandomColor(),
                    watched_lessons_count: 0,
                    total_lessons_count: 5,
                    total_earned_points: 0,
                    total_possible_points: 100,
                    isInWishlist: true
                }));
                setWishlistCourses(updatedWishlist);

                const ids = new Set(updatedWishlist.map(course => course.id));
                setWishlistIds(ids);
            }
        } catch (error) {
            console.error("خطا در دریافت لیست علاقه‌مندی‌ها:", error);
        }
    };

    // افزودن به علاقه‌مندی‌ها
    const addToWishlist = async (courseId, courseTitle) => {
        setLoadingWishlist(true);
        try {
            const response = await api.post(`/pre_student/api/v3/wishlist/add/${courseId}/`);

            if (response.status === 200 || response.status === 201) {
                setWishlistIds(prev => new Set([...prev, courseId]));

                setCourses(prevCourses =>
                    prevCourses.map(course =>
                        course.id === courseId
                            ? { ...course, isInWishlist: true }
                            : course
                    )
                );

                alert(`دوره "${courseTitle}" با موفقیت به لیست علاقه مندی ها اضافه شد`);
            }
        } catch (error) {
            console.error("خطا در افزودن به علاقه‌مندی‌ها:", error);
            alert("خطا در افزودن دوره به لیست علاقه مندی ها");
        } finally {
            setLoadingWishlist(false);
        }
    };

    // حذف از علاقه‌مندی‌ها
    const removeFromWishlist = async (courseId, courseTitle) => {
        setLoadingWishlist(true);
        try {
            const response = await api.delete(`/pre_student/api/v3/wishlist/remove/${courseId}/`);

            if (response.status === 200) {
                setWishlistIds(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(courseId);
                    return newSet;
                });

                setCourses(prevCourses =>
                    prevCourses.map(course =>
                        course.id === courseId
                            ? { ...course, isInWishlist: false }
                            : course
                    )
                );

                if (activeTab === 'wishlist') {
                    setWishlistCourses(prevCourses =>
                        prevCourses.filter(course => course.id !== courseId)
                    );
                }

                alert(`دوره "${courseTitle}" با موفقیت از لیست علاقه مندی ها حذف شد`);
            }
        } catch (error) {
            console.error("خطا در حذف از علاقه‌مندی‌ها:", error);
            alert("خطا در حذف دوره از لیست علاقه مندی ها");
        } finally {
            setLoadingWishlist(false);
        }
    };

    // تغییر وضعیت علاقه‌مندی
    const toggleWishlist = async (courseId, courseTitle, e) => {
        e.stopPropagation();

        if (loadingWishlist) return;

        if (wishlistIds.has(courseId)) {
            await removeFromWishlist(courseId, courseTitle);
        } else {
            await addToWishlist(courseId, courseTitle);
        }
    };

    // تغییر تب
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'wishlist' && wishlistCourses.length === 0) {
            fetchWishlist();
        }
    };

    // رفتن به صفحه جزئیات دوره
    const goToCourseDetail = (courseId) => {
        navigate(`/course-detail/${courseId}`);
    };

    // کامپوننت دکمه قلب
    const HeartButton = ({ isInWishlist, onClick, courseId, courseTitle, isLoading }) => (
        <button
            onClick={(e) => onClick(courseId, courseTitle, e)}
            disabled={isLoading}
            style={{
                position: "absolute",
                top: "8px",
                left: "8px",
                background: "white",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: isLoading ? "wait" : "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                zIndex: 10,
                transition: "all 0.2s ease",
                opacity: isLoading ? 0.7 : 1
            }}
            className="heart-button"
        >
            <svg
                width="20"
                height="18"
                viewBox="0 0 23 21"
                fill={isInWishlist ? "#FB0303" : "none"}
                stroke="#FB0303"
                strokeWidth="2"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.2s ease"
                }}
            >
                <path
                    d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L3.67129 11.4518L11.4513 19.2318L19.2313 11.4518L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z"
                    fill={isInWishlist ? "#FB0303" : "none"}
                    stroke="#FB0303"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );

    // رندر کردن دوره‌ها
    const renderCourses = (coursesList, isWishlist = false) => {
        if (loading && !isWishlist) {
            return (
                <div className="text-center py-5">
                    <div className="spinner-border text-success" role="status">
                        <span className="visually-hidden">در حال بارگذاری...</span>
                    </div>
                    <p className="mt-2">در حال بارگذاری دوره‌ها...</p>
                </div>
            );
        }

        if (coursesList.length === 0) {
            return (
                <div className="text-center py-5">
                    <p style={{ color: "#666", fontSize: "16px" }}>
                        {isWishlist ? "لیست علاقه‌مندی‌های شما خالی است!" : "شما هیچ دوره‌ای ندارید!"}
                    </p>
                </div>
            );
        }

        return coursesList.map((course) => (
            <div
                key={course.id}
                className="col-12 mt-3 px-0 col-lg-4 px-lg-1"
                onClick={() => goToCourseDetail(course.id)}
                style={{ cursor: "pointer" }}
            >
                <div className="d-flex" style={{ position: "relative" }}>
                    {!isWishlist && (
                        <HeartButton
                            isInWishlist={wishlistIds.has(course.id)}
                            onClick={toggleWishlist}
                            courseId={course.id}
                            courseTitle={course.title}
                            isLoading={loadingWishlist}
                        />
                    )}

                    {isWishlist && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                removeFromWishlist(course.id, course.title);
                            }}
                            style={{
                                position: "absolute",
                                top: "8px",
                                left: "8px",

                                background: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                zIndex: 10,
                                transition: "all 0.2s ease"
                            }}
                            className="heart-button"
                        >
                            <svg
                                width="20"
                                height="18"
                                viewBox="0 0 23 21"
                                fill="#FB0303"
                                stroke="#FB0303"
                                strokeWidth="2"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L3.67129 11.4518L11.4513 19.2318L19.2313 11.4518L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z"
                                    fill="#FB0303"
                                    stroke="#FB0303"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    )}

                    <div className="">
                        <img
                            src={`${course.logo_url}`}
                            alt={course.title}
                            style={{ width: "130px", height: "134px", backgroundColor: "white", borderRadius: "0 16px 16px 0" }}
                        />
                    </div>
                    <div className="course-container">
                        <div style={{ fontWeight: "500", marginBottom: "8px" }}>{course.title}</div>

                        {isWishlist && course.teacher_name && (
                            <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>
                                مدرس: {course.teacher_name}
                            </div>
                        )}

                        <div className="d-flex flex-wrap">
                            <div className="d-flex align-items-center">
                                <svg className="ms-1" width="15" height="15" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5884 0.372829L7.9246 3.05663C8.023 3.25103 8.2102 3.38723 8.428 3.41963L11.4262 3.85583C11.6014 3.88163 11.761 3.97283 11.8666 4.11323C11.9746 4.25423 12.019 4.43003 11.9932 4.60343C11.9722 4.74623 11.9038 4.88003 11.8012 4.98083L9.628 7.08563C9.469 7.23563 9.3964 7.45103 9.4336 7.66403L9.9706 10.6268C10.0288 10.9808 9.7924 11.3156 9.4336 11.3882C9.2884 11.4116 9.1384 11.3882 9.007 11.3204L6.3304 9.92603C6.1312 9.82523 5.8972 9.82523 5.7004 9.92603L3.0238 11.3204C2.6926 11.4962 2.281 11.3744 2.1022 11.051C2.035 10.922 2.0116 10.7744 2.0326 10.6316L2.5684 7.66883C2.6068 7.45823 2.5342 7.23983 2.3746 7.08983L0.201397 4.98743C0.0753973 4.86323 0.00219727 4.69463 0.00219727 4.51883C0.00219727 4.34303 0.0753973 4.17443 0.201397 4.05023C0.304597 3.94703 0.440197 3.87923 0.588397 3.86063L3.5866 3.42443C3.8038 3.39143 3.991 3.25823 4.0876 3.06143L5.3788 0.372829C5.491 0.145429 5.728 0.000228809 5.9884 0.00502881H6.0682C6.2932 0.0332288 6.49 0.171229 6.5884 0.372829Z" fill="#FCCB40" />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00465 9.84631C5.88705 9.84631 5.77725 9.88591 5.67165 9.93751L3.00465 11.3277C2.68365 11.4891 2.27805 11.3601 2.10225 11.0511C2.03445 10.9245 2.00865 10.7793 2.03205 10.6359L2.56845 7.68091C2.60385 7.46491 2.53125 7.24951 2.37405 7.09711L0.19665 4.99231C-0.06555 4.73491 -0.06555 4.31491 0.19665 4.05511C0.29985 3.95431 0.43365 3.88831 0.57645 3.86731L3.58605 3.42451C3.81525 3.39151 3.98205 3.26311 4.08705 3.06151L5.39505 0.34231C5.49345 0.12211 5.82885 -0.0302901 6.00945 0.00510993C6.00465 0.18571 6.00465 9.72691 6.00465 9.84631Z" fill="#FAC025" />
                                </svg>
                                <span className="ps-2" style={{ fontSize: "12px" }}>
                                    {isWishlist ? `${course.total_earned_points || 0} از ${course.total_possible_points || 0} امتیاز` : `${course.total_earned_points} از ${course.total_possible_points} امتیاز`}
                                </span>
                            </div>
                            <div className="px-2" style={{ fontSize: "12px", borderRight: "1px solid #ddd", marginLeft: "8px" }}>
                                {course.duration_hours} ساعت و {course.duration_minutes} دقیقه
                            </div>

                            {/* نمایش قیمت فقط برای لیست علاقه‌مندی‌ها */}
                            {isWishlist && !course.is_free && (
                                <div className="px-2" style={{ fontSize: "12px" }}>
                                    {course.price_without_discount && parseInt(course.price_without_discount) > parseInt(course.price) ? (
                                        <>
                                            <span style={{ textDecoration: "line-through", color: "#999", marginLeft: "5px" }}>
                                                {parseInt(course.price_without_discount).toLocaleString()} تومان
                                            </span>
                                            <span style={{ color: "#2BA769", fontWeight: "bold" }}>
                                                {parseInt(course.price).toLocaleString()} تومان
                                            </span>
                                        </>
                                    ) : (
                                        <span>{parseInt(course.price).toLocaleString()} تومان </span>
                                    )}
                                </div>
                            )}
                            
                            {/* نمایش قیمت برای دوره‌های رایگان فقط در لیست علاقه‌مندی‌ها */}
                            {isWishlist && course.is_free && (
                                <div className="px-2" style={{ fontSize: "12px" }}>
                                    {course.price_without_discount && parseInt(course.price_without_discount) > 0 ? (
                                        <>
                                            <div style={{ textDecoration: "line-through", color: "#999", marginLeft: "5px"  , display:"inline"}}>
                                                {parseInt(course.price_without_discount).toLocaleString()} تومان 
                                            </div>
                                            <span style={{ color: "#2BA769", fontWeight: "bold" }}>
                                                  رایگان
                                            </span>
                                        </>
                                    ) : (
                                        <span style={{ color: "#2BA769" }}> رایگان </span>
                                    )}
                                </div>
                            )}
                        </div>

                        {!isWishlist && (
                            <div className="d-flex mt-2">
                                <div>
                                    <div className="scrollbar">
                                        {Array.from({ length: course.total_lessons_count }).map((_, index) => (
                                            <div
                                                key={index}
                                                className="scrollbar-segment"
                                                style={{
                                                    backgroundColor:
                                                        index < course.watched_lessons_count
                                                            ? course.progressColor
                                                            : '#E8F1FF',
                                                    width: `calc(${100 / course.total_lessons_count}% - 1px)`,
                                                    margin:" 0 0.5px",
                                                    height: "100%",
                                                    display: "inline-block"
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className="me-2" style={{ fontSize: "12px" }}>
                                    {course.watched_lessons_count}/{course.total_lessons_count}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <div className="ms-lg-2 p-3 pt-lg-0 pt-3 pe-0 pe-lg-4">
            <div className="d-flex justify-content-center">

            </div>

            <br></br>

            <br></br>

            <div className="d-flex mx-lg-5 mx-0">
                <div className="d-flex justify-content-between w-25 w-100-ph" style={{ overflowY: "auto" }}>
                    <button
                        className={`course-btn mx-2 ${activeTab === 'my-courses' ? '' : 'bg-light1'}`}
                        onClick={() => handleTabChange('my-courses')}
                        style={{
                            backgroundColor: activeTab === 'my-courses' ? '#2BA769' : 'white',
                            color: activeTab === 'my-courses' ? 'white' : 'black',
                            transition: "all 0.3s ease"
                        }}
                    >
                        <svg className="ms-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.5401 6.42C22.4213 5.94541 22.1794 5.51057 21.8387 5.15941C21.4981 4.80824 21.0708 4.55318 20.6001 4.42C18.8801 4 12.0001 4 12.0001 4C12.0001 4 5.12008 4 3.40008 4.46C2.92933 4.59318 2.50206 4.84824 2.16143 5.19941C1.8208 5.55057 1.57887 5.98541 1.46008 6.46C1.1453 8.20556 0.991319 9.97631 1.00008 11.75C0.988863 13.537 1.14285 15.3213 1.46008 17.08C1.59104 17.5398 1.83839 17.9581 2.17823 18.2945C2.51806 18.6308 2.9389 18.8738 3.40008 19C5.12008 19.46 12.0001 19.46 12.0001 19.46C12.0001 19.46 18.8801 19.46 20.6001 19C21.0708 18.8668 21.4981 18.6118 21.8387 18.2606C22.1794 17.9094 22.4213 17.4746 22.5401 17C22.8524 15.2676 23.0064 13.5103 23.0001 11.75C23.0113 9.96295 22.8573 8.1787 22.5401 6.42Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.75 15.02L15.5 11.75L9.75 8.48V15.02Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        ویدیو های من
                    </button>

                    <button
                        className={`course-btn ${activeTab === 'wishlist' ? '' : 'bg-light1'}`}
                        onClick={() => handleTabChange('wishlist')}
                        style={{
                            backgroundColor: activeTab === 'wishlist' ? '#2BA769' : 'white',
                            color: activeTab === 'wishlist' ? 'white' : 'black',
                            transition: "all 0.3s ease"
                        }}
                    >
                        <svg className="ms-2" width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L3.67129 11.4518L11.4513 19.2318L19.2313 11.4518L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z" fill={activeTab === 'wishlist' ? "white" : "#FB0303"} stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        علاقه مندی ها
                    </button>
                </div>
            </div>

            <br></br>

            <div className="">
                <div className="row w-lg-75 mx-0 mx-lg-auto">
                    {activeTab === 'my-courses' && renderCourses(courses, false)}
                    {activeTab === 'wishlist' && renderCourses(wishlistCourses, true)}
                </div>
            </div>
        </div>
    );
}

export default CoursePage;